import { Colors } from "@/enums/Colors";
import { Spinner } from "@/external/ensolvers-core-frontend-mui-v5/components/Common/Spinner";
import { Box, Dialog, DialogContent, DialogProps, Typography, styled } from "@mui/material";
import CommonButton from "./CommonButton";

const CommonButtonSx = {
  width: "158.5px",
  height: "44px",
  textTransform: "none",
  padding: 0,
  borderRadius: "8px",
  fontSize: "14px",
};

const StyledDialog = styled(Dialog)(() => ({
  position: "absolute",
  "& .MuiDialog-paper": {
    width: "381px",
    height: "auto",
    borderRadius: "1rem",
    "& .MuiDialogContent-root": {
      padding: "24px",
      overflow: "hidden",
    },
  },
}));

const Container = styled(Box)(() => ({
  "&.content-container": {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  "&.button-container": {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    height: "44px",
    gap: "1rem",
  },
}));

const Text = styled(Typography)(() => ({
  "&.modal-title": {
    fontWeight: "bold",
    fontSize: "14px",
  },
  "&.modal-content": {
    color: Colors.LIGHT_GRAY_8A8E93,
    fontSize: "12px",
  },
}));

interface Props {
  showModal: boolean;
  handleOnClose: () => void;
  handleButtonClick: () => void;
  title: string;
  description?: string;
  leftButtonText?: string;
  rightButtonText: string;
  leftButtonColor?: string;
  leftButtonBackgroundColor?: string;
  rightButtonColor?: string;
  rightButtonBackgroundColor?: string;
  children?: React.ReactNode | JSX.Element | JSX.Element[];
  dialogProps?: Omit<DialogProps, "open" | "onClose">;
  confirming?: boolean;
}

export const CommonDialog = ({
  showModal,
  handleOnClose,
  handleButtonClick,
  title,
  description,
  leftButtonText,
  rightButtonText,
  leftButtonBackgroundColor,
  rightButtonBackgroundColor,
  children,
  dialogProps,
  confirming,
}: Props) => {
  return (
    <StyledDialog {...dialogProps} open={showModal} onClose={handleOnClose}>
      <DialogContent>
        <Container className="content-container">
          <Text className="modal-title">{title}</Text>
          {description && <Text className="modal-content">{description}</Text>}
          {children}
          <Container className="button-container">
            {leftButtonText && (
              <CommonButton
                backgroundColor={leftButtonBackgroundColor}
                purpleBorderVariant
                onClick={handleOnClose}
                sx={{ ...CommonButtonSx }}
                disabled={confirming ?? false}
              >
                {leftButtonText}
              </CommonButton>
            )}
            <CommonButton
              backgroundColor={rightButtonBackgroundColor}
              onClick={handleButtonClick}
              sx={{ ...CommonButtonSx }}
              disabled={confirming ?? false}
              endIcon={confirming && <Spinner variant="indeterminate" size={"1em"} />}
            >
              {rightButtonText}
            </CommonButton>
          </Container>
        </Container>
      </DialogContent>
    </StyledDialog>
  );
};
